export default async function getMenuData(){
    return []
}